import React from "react"

import useStyles from "@/components/Messages/MediaMessage/AudioPlayer/styles"

import HardCodedService from "@/services/HardCoded"

type AudioPlayerProps = {
	src: string
	type?: string
}

const AudioPlayer: React.FC<AudioPlayerProps> = (props) => {
	const { src, type } = props

	const defaultType = HardCodedService.checkFeatureFlagByInstanceId("mpegAudioTester") ? "audio/mpeg" : "audio/ogg"

	const classes = useStyles()

	return (
		<audio
			controls
			className={classes.audioPlayer}
		>
			<source src={src} type={type || defaultType} />
		</audio>
	)
}

export default AudioPlayer
